import React, { useState, useEffect } from 'react';
import { Grid, Col, Row, Button } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import _ from 'lodash';
import '../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

export default function SelectModules({ moduleTypes, nominatedModules, addModule, editModule, deselectNominatedItem }) {
    const [availableRowSelected, setAvailableRowSelected] = useState(false);
    const [availableIDSelected, setAvailableIDSelected] = useState(-1);
    const [selectedAvailModules, setSelectedAvailModules] = useState([]);
    const [selectedNominatedModules, setSelectedNominatedModules] = useState([]);

    useEffect(() => {
        if (deselectNominatedItem) {
            setSelectedNominatedModules([]);
        }
    }, [deselectNominatedItem]);

    function addModuleClicked() {
        addModule(availableIDSelected);
        setAvailableRowSelected(false);
        setSelectedAvailModules([]);
    }

    function onAvailableRowClicked(row, isSelected) {
        setAvailableRowSelected(isSelected);
        setAvailableIDSelected(isSelected ? row.module_type_id : -1);
        setSelectedAvailModules(isSelected ? [row.module_type_id] : []);
    }

    function onNominatedRowClicked(row, isSelected) {
        editModule(row, isSelected);
        setSelectedNominatedModules(isSelected ? [row.event_grouping_seq] : []);
    }

    const emptyRowStyle = { height: '20px' };
    const selectAvailableRowProp = {
        mode: 'radio', clickToSelect: true, bgColor: 'yellow',
        hideSelectColumn: true, onSelect: onAvailableRowClicked,
        selected: selectedAvailModules,
    };
    const selectNominatedRowProp = {
        mode: 'radio', clickToSelect: true, bgColor: 'yellow',
        hideSelectColumn: true, onSelect: onNominatedRowClicked,
        selected: selectedNominatedModules,
    };
    const optionsAvailable = { defaultSortName: 'module_type', defaultSortOrder: 'asc' };
    const optionsSelected = { defaultSortName: 'module_type_description', defaultSortOrder: 'asc' };

    return (
        <div>
            <Grid>
                <Col xs={5}>
                    <Row>
                        <BootstrapTable data={moduleTypes} selectRow={selectAvailableRowProp} options={optionsAvailable} striped hover height='200px'>
                            <TableHeaderColumn hidden isKey={true} dataField='module_type_id'>ID</TableHeaderColumn>
                            <TableHeaderColumn dataField='module_type'>Available Modules</TableHeaderColumn>
                            <TableHeaderColumn hidden dataField='multiple_allowed'>Multiple Allowed</TableHeaderColumn>
                            <TableHeaderColumn width="20%" hidden dataField='visible' filter={{ type: 'TextFilter', defaultValue: 'true' }}>
                                Visible
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </Row>
                    <Row style={emptyRowStyle} />
                    <Row>
                        <Button style={{ width: '100%' }} bsStyle="primary"
                            disabled={!availableRowSelected}
                            onClick={addModuleClicked}>
                            {'Add Module >>'}
                        </Button>
                    </Row>
                </Col>
                <Col xs={1} />
                <Col xs={5}>
                    <Row>
                        <BootstrapTable data={nominatedModules} selectRow={selectNominatedRowProp} options={optionsSelected} striped hover height='200px'>
                            <TableHeaderColumn hidden isKey dataField='event_grouping_seq'>ID</TableHeaderColumn>
                            <TableHeaderColumn dataField='module_type_description'>Selected Modules</TableHeaderColumn>
                        </BootstrapTable>
                    </Row>
                    <Row style={emptyRowStyle} />
                </Col>
            </Grid>
        </div>
    );
}
